export default "__VITE_ASSET__81QDueuf__"